import React, { useMemo } from "react"
import { Outlet } from "react-router-dom"
import { useQuery } from "@apollo/client"
import ALL_CUSTOM_STATES from "../../graphql/queries/settings/customState/AllCustomStates"
import { CustomState, StoreGroup } from "lib/types/generated/graphql-types"
import ALL_STORE_GROUPS from "../../graphql/queries/store/AllStoreGroups"
import { CustomerOrders } from "../../classes/customer/CustomerOrders"

export const Customer = () => {
  const { data: customStatesData } = useQuery(ALL_CUSTOM_STATES)
  const { data: storeGroupsData } = useQuery(ALL_STORE_GROUPS)

  const customStates: CustomState[] = customStatesData?.Order?.customStates?.states ?? []
  const storeGroups: StoreGroup[] = storeGroupsData?.getStoreGroups ?? []

  const customerOrders = useMemo(() => new CustomerOrders(customStates, storeGroups), [customStates, storeGroups])

  return <Outlet context={{ customerOrders }} />
}
